import useSystemTime from "./stub_time";
useSystemTime();

export default useSystemTime;
